<template>
	<div>
		<div class="container">
			<div class="handle-box">
				<el-select size="small" v-if="isAdmin" @change="agentChange" v-model="query.agentId" filterable
					clearable placeholder="代理商" class="handle-select mr10" style="width: 260px" popper-class="eloption"
					:popper-append-to-body="true">
					<el-option v-for="item in agents" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-select size="small" v-if="isSubAgent" v-model="query.subAgentId" @change="getfetchDefaultCompanies"
					filterable clearable placeholder="子代理" class="handle-select mr10" style="width: 260px;">
					<el-option v-for="item in subAgentList" :key="item.id" :label="item.name"
						:value="item.id"></el-option>
				</el-select>
				<el-select size="small" style="width: 260px" v-if="isAgent" v-model="query.companyId"
					@change="companyChange" filterable clearable placeholder="企业" class="handle-select mr10"
					popper-class="eloption" :popper-append-to-body="true">
					<el-option v-for="item in companys" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-select size="small" v-model="query.departmentId" v-show="isNormal" @change="departmentChange"
					filterable clearable placeholder="部门" class="handle-select mr10" style="width: 180px"
					popper-class="eloption" :popper-append-to-body="true">
					<el-option v-for="item in departments" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-select size="small" v-model="query.userId" filterable clearable placeholder="员工"
					class="handle-select mr10" style="width: 180px" v-show="isNormal">
					<el-option v-for="item in users" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>

				<el-date-picker size="small" v-model="timeArr" type="daterange" unlink-panels class="m_r_10"
					range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
				<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search" style="margin-top: 10px;"
					@click="handleSearch">搜索</el-button>
			</div>

			<div class="card-body" v-if="crmSumList?.length">
				<div class="tit">
					<div><i class="el-icon-s-data"></i>统计数据</div>
				</div>
				<div class="card-list">
					<div class="bg_eff5f7" v-for="(item , index) in crmSumList" :key="index">
						<span class="card-list-tit">{{item.label}}</span>
						<span class="card-list-data">{{item.value||0}}</span>
					</div>
				</div>
			</div>
			<el-table :data="tableData" border class="table" ref="multipleTable" v-loading="loading"
				:row-style="{ height: '20px' }" :cell-style="columnbackgroundStyle" max-height="600"
				:header-cell-style="{ 'text-align': 'center' }" header-cell-class-name="table-header" stripe
				:tree-props="{ children: 'children' }" @header-dragend="handleHeaderDragEnd">
				<el-table-column v-for="item in columnList" :key="item.value" :prop="item.label" :label="item.value"
					align="center" resizable></el-table-column>
			</el-table>
			<div class="pagination">
				<el-pagination background layout="total, sizes, prev, pager, next, jumper"
					:current-page="query.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
					:page-size="query.pageSize" :total="pageTotal" @size-change="handleSizeChange"
					@current-change="handlePageChange"></el-pagination>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		fetchDepartment,
		fetchUsersByDepartmentId,
		fetchDefaultUsers
	} from '../../api/index.js';
	import {
		fetchCompanyByAgentId,
		fetchDefaultCompanies
	} from '../../api/companyIndex';
	import {
		fetchAgent
	} from '../../api/agentIndex';
	import {
		getCrmSum,
		download
	} from '../../api/sumIndex';
	import {
		querySubAgent
	} from '../../api/serialIndex.js';
	export default {
		name: 'CRMstatistics',
		data() {
			return {
				loading: false,
				theme: localStorage.getItem('theme'),
				theme2: localStorage.getItem('theme2'),
				theme3: localStorage.getItem('theme3'),
				theme4: localStorage.getItem('theme4'),
				theme5: localStorage.getItem('theme5'),
				theme6: localStorage.getItem('theme6'),
				theme8: localStorage.getItem('theme8'),
				query: {
					companyId: '',
					startTime: '',
					endTime: '',
					pageIndex: 1,
					pageSize: 10,
				},
				hasChildren: true,
				fileList: [],
				tableData: [],
				agents: [],
				companys: [],
				departments: [],
				users: [],
				multipleSelection: [],
				delList: [],
				showId: false,
				editVisible: false,
				addVisible: false,
				addButton: false,
				updateButton: false,
				isNotAdmin: true,
				isShow: false,
				isAgent: false,
				isAdmin: false,
				isSubAgent: false,
				isCompany: false,
				pageTotal: 0,
				form: {
					companyName: '',
					contactName: '',
					phoneNumber: '',
					userId: '',
					status: '未打',
				},
				idx: -1,
				id: -1,
				token: {
					Authorization: localStorage.getItem('token'),
					type: 'web',
					UserRole: localStorage.getItem('ms_role'),
					XSecurityVersion: 'v2',
				},
				path: process.env.BASE_URL,
				timeArr: [],

				columnList: [],
				crmSumList: [],
			};
		},
		created() {
			let role = localStorage.getItem('ms_role');
			this.subAgent = localStorage.getItem('subAgent');
			this.getTime();
			if (role === 'admin') {
				this.isAdmin = true;
				this.isAgent = true;
				this.isNotAdmin = false;
				fetchAgent(localStorage.getItem('user')).then(res => {
					this.agents = res.data;
				});
			}

			if (role === 'agent') {
				this.isAgent = true;
				this.isNotAdmin = false;
				if (this.subAgent == 'true') {
					this.isSubAgent = true;
					this.getquerySubAgent();
				} else {
					this.isSubAgent = false;
				}
			}
			if (role === 'subAgent') {
				this.isAgent = true;
			}
			if (role === 'company') {
				this.isCompany = true;

				let data = {
					companyId: '',
					currentUserId: localStorage.getItem('user'),
				};
				fetchDepartment(data).then(res => {
					this.departments = res.data;
				});
			}
			if (role === 'department') {
				let data = {
					companyId: '',
					currentUserId: localStorage.getItem('user'),
				};
				fetchDepartment(data).then(res => {
					this.departments = res.data;
				});
			}
			this.init();
			this.updatePaginationStyle();
		},
		methods: {
			updatePaginationStyle() {
				let pagination = document.getElementById('pagination');
				if (!pagination) {
					pagination = document.createElement('style');
					pagination.id = 'dynamic-tab-style';
					document.head.appendChild(pagination);
				}
				pagination.innerHTML = `
				    .el-pager .active {
				        background-color: ${this.theme8} !important;
						color: #fff !important;
				    }
					.el-pager .number:hover {
				        color: ${this.theme8} !important;
				    }
					.el-pager .active:hover {
					    color: #fff !important;
					}
					.el-pager .more:hover {
					    color: ${this.theme8} !important;
					}
				`;
			},
			handleHeaderDragEnd(newWidth, oldWidth, column, event) {
				console.log('列宽调整完成：', column.label, newWidth);
				// 可在此处保存列宽到本地存储或数据库
			},
			getfetchDefaultCompanies() {
				this.query.companyId = '';
				let data = {
					currentUserId: localStorage.getItem('user'),
					subAgentId: this.query.subAgentId,
				};
				fetchDefaultCompanies(data).then(res => {
					if (res?.code === 200) {
						this.companys = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getquerySubAgent() {
				let data = {
					agentId: this.query.agentId,
					userId: localStorage.getItem('user'),
				};
				querySubAgent(data).then(res => {
					if (res?.code === 200) {
						this.subAgentList = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			init() {
				fetchAgent(localStorage.getItem('user')).then(res => {
					this.agents = res.data;
				});
				if (this.subAgent == true) {
					this.isSubAgent = true;
					this.getquerySubAgent();
				}
				this.getfetchDefaultCompanies();
				let data = {
					companyId: '',
					currentUserId: localStorage.getItem('user'),
				};
				fetchDepartment(data).then(res => {
					this.departments = res.data;
				});
				fetchDefaultUsers(localStorage.getItem('user')).then(res => {
					this.users = res.data;
				});
			},
			columnbackgroundStyle({
				row,
				column,
				rowIndex,
				columnIndex
			}) {

				if (this.query.sortField == 'totalPickUp') {
					if (columnIndex == 7) {
						return 'background:#FFFF33;';
					}
				}
				if (this.query.sortField == 'totalIntention') {
					if (columnIndex == 10) {
						return 'background:#FFFF33;';
					}
				}
				if (this.query.sortField == 'averageDuration') {
					if (columnIndex == 11) {
						return 'background:#FFFF33;';
					}
				}
				if (this.query.sortField == 'intentionP') {
					if (columnIndex == 12) {
						return 'background:#FFFF33;';
					}
				}
				if (this.query.sortField == 'totalDuration') {
					if (columnIndex == 13) {
						return 'background:#FFFF33;';
					}
				}
				if (this.query.sortField == 'carrierCallDuration') {
					if (columnIndex == 14) {
						return 'background:#FFFF33;';
					}
				}
			},

			agentChange(agentId) {
				this.query.agentId = agentId;
				this.query.companyId = '';
				this.query.departmentId = '';
				this.query.userId = '';
				this.form.agentId = agentId;
				this.form.companyId = '';
				this.form.departmentId = '';
				this.form.userId = '';
				if (agentId) {
					let data = {
						subAgent: JSON.parse(localStorage.getItem('subAgent').toLowerCase()),
						agentId: agentId,
					};
					fetchCompanyByAgentId(data).then(res => {
						this.companys = res.data;
					});
				}
			},
			companyChange(companyId) {
				this.query.companyId = companyId;
				this.query.departmentId = '';
				this.query.userId = '';
				this.form.companyId = companyId;
				this.form.departmentId = '';
				this.form.userId = '';
				let data = {
					companyId: companyId,
					currentUserId: localStorage.getItem('user'),
				};
				fetchDepartment(data).then(res => {
					this.departments = res.data;
					this.query.pageIndex = 1;
					this.getData();
				});
			},
			departmentChange(departmentId) {
				let data = {
					departmentId: departmentId,
					currentUserId: localStorage.getItem('user'),
				};
				fetchUsersByDepartmentId(data).then(res => {
					this.users = res.data;
				});
			},
			tableRowClassName({
				row,
				rowIndex
			}) {
				if (rowIndex === 1) {
					return 'warning-row';
				} else if (rowIndex === 3) {
					return 'success-row';
				}
				return '';
			},
			// 获取数据
			uploadExcel() {
				this.upload = true;
			},
			getTime() {
				let startTime = new Date(new Date());
				let endTime = new Date();
				this.timeArr.push(startTime);
				this.timeArr.push(endTime);
			},

			getData() {
				this.loading = true;
				this.tableData = [];
				// 日期
				if (this.timeArr === null) {
					this.$message.error('时间不能为空');
					return;
				}
				let startTime = this.toDateTimeStr(this.timeArr[0]);
				let endTime = this.toDateTimeStr(this.timeArr[1]);

				this.query.startTime = startTime;
				this.query.endTime = endTime;
				getCrmSum(this.query).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData = res.data.list;
						this.columnList = res.customData.column;
						this.crmSumList = res.customData.crmSum;
						this.pageTotal = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			toDateTimeStr(date) {
				let y = date.getFullYear();
				let m = date.getMonth() + 1;
				let d = date.getDate();
				if (m < 10) {
					m = '0' + m;
				}
				if (d < 10) {
					d = '0' + d;
				}
				return y + '-' + m + '-' + d;
			},
			// 触发搜索按钮
			handleSearch() {
				this.query.pageIndex = 1;
				this.getData();
			},
			// 分页导航
			handlePageChange(val) {
				this.query.pageIndex = val;
				this.getData();
			},
			handleSizeChange(val) {
				this.query.pageSize = val;
				this.query.pageIndex = 1; // 重置到第一页
				this.getData();
			}
		}
	};
</script>

<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}

	/* a:hover{background: #66b1ff} */
	.handle-select {
		width: 120px;
	}

	.table {
		width: 100%;
		font-size: 12px;
	}

	.red {
		color: #ff0000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.handle-input {
		width: 200px;
		display: inline-block;
	}


	.card-body {
		color: rgba(0, 0, 0, 0.65);
		background: #fff;
		border-radius: 2px;
		box-sizing: border-box;
		padding: 24px 0;

	}

	.card-body .tit {
		font-weight: 700;
		color: rgba(0, 0, 0, 0.85);
		margin-bottom: 1em;
		font-size: 14px;
		font-variant: tabular-nums;
		line-height: 1.5;
		list-style: none;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}

	.el-icon-s-data,
	.el-icon-postcard,
	.el-icon-finished {
		font-size: 20px;
		margin-right: 5px;
		color: #1890FF;
	}

	.card-body .card-list {
		display: flex;
		flex-direction: row;
		overflow-x: auto;
	}

	.card-body .card-list div {
		padding: 11px 10px;
		zoom: 1;
		width: 23%;
		display: flex;
		flex-direction: column;
		margin-right: 2%;
		background: #dfeef3;
		min-width: 60px;
	}

	.card-body .tit .tit-btn .active {
		color: #fff;
	}

	.card-body .card-list .card-list-tit {
		font-size: 18px;
		font-weight: 600;
		color: rgba(0, 0, 0, 0.65);
	}

	.card-body .card-list .card-list-data {
		font-size: 16px;
		margin-top: 10px;
		font-weight: 700;
	}

	.card-body .card-list .card-list-qoq {
		font-size: 12px;
		margin-top: 10px;
	}
</style>